import { object, string, number } from 'yup';

export const SampleSlidesServicesSchema = object({
  name: string().min(1).required(),
  count: number().min(0),
});
